module.exports = __webpack_public_path__ + "img/yostarBottom.6aef7d4b.png";